import React from 'react';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';
import { Classes } from '@blueprintjs/core';

import cls from './Nav.module.css';

export default function () {
  return (
    <div className={cls.controlMenu}>
      <NavLink
        className={cx(Classes.BUTTON, Classes.MINIMAL, cls.link)}
        to="/dashboard"
        activeClassName={Classes.INTENT_PRIMARY}
        data-test="sign-in-button"
      >
        {'Sign in'}
      </NavLink>
    </div>
  );
}
